import { useTheme } from "@mui/system";
import { FC } from "react";
import ReactApexChart from "react-apexcharts";

interface Props {
  height: string | number;
}
const ThreeColumnChart: FC<Props> = ({ height }) => {
  const theme = useTheme();

  const series = [
    {
      name: "Net Profit",
      data: [45, 40, 30, 40, 30, 60, 56, 60, 50],
    },
    {
      name: "Revenue",
      data: [65, 60, 40, 60, 60, 70, 80, 70, 60],
    },
    {
      name: "Free Cash Flow",
      data: [25, 45, 35, 45, 55, 65, 43, 65, 55],
    },
  ];
  const options: object = {
    chart: {
      type: "bar",
      width: "100%",
      background: "transparent",
      toolbar: {
        show: false,
      },
    },
    colors: [
      theme.palette.primary[200],
      theme.palette.primary.main,
      theme.palette.primary[400],
    ],
    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: "60%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    theme: {
      mode: theme.palette.mode,
    },
    grid: {
      show: true,
      borderColor: theme.palette.grey[300],
      padding: {
        top: -20,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    stroke: {
      show: true,
      width: 1.5,
      colors: [
        theme.palette.mode === "light"
          ? "#fff"
          : theme.palette.background.paper,
      ],
    },
    yaxis: {
      show: true,
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
  };
  return (
    <ReactApexChart
      options={options}
      series={series}
      width="100%"
      type="bar"
      height={height}
    />
  );
};

export default ThreeColumnChart;
